<div
  *ngIf="selectableType === type.COMPARE"
  class="container compare-footer">
  <div
    [ngClass]="{'compare-content--collapsed': sidenavCollapsed}"
    class="compare-content">

    <cui-button
      (buttonClicked)="cancel()"
      [label]="'CANCEL' | translate"
      [type]="'secondary'">
    </cui-button>

    <div *ngIf="(isLoading$ | async) === false" class="selections">
      <ng-container
        *ngFor="let selection of selections; let last = last">
        <div class="selections__item">
          <span class="item__label">
            {{(selectableFeature === feature.FLOORS ? ('Floor' | translate) + ' ' : '') + (selection | compareName : names : selectableFeature)}}
          </span>
          <mat-icon (click)="remove(selection)" class="close-icon remove">close</mat-icon>
        </div>
        <div *ngIf="!last" class="separator"></div>
      </ng-container>
    </div>

    <div *ngIf="isLoading$ | async" class="selections">
      <ng-container
        *ngFor="let selection of selections; let last = last">
        <div class="selections-skeleton">
          <div class="skeleton--animated"></div>
        </div>
        <div *ngIf="!last" class="separator"></div>
      </ng-container>
    </div>

    <div class="label">
      <span *ngIf="!selections || selections?.length === 0">{{'Select and compare up to 3 items' | translate}}</span>
      <span *ngIf="selections?.length === 1">{{'Select at least 2 items' | translate}}</span>
    </div>

    <div>

    </div>

    <cui-button
      (buttonClicked)="compare()"
      *ngIf="selections?.length >= 2"
      [label]="'COMPARE' | translate"
      [type]="'primary'">
    </cui-button>
  </div>
</div>

